// extracted by mini-css-extract-plugin
export var divider = "_hx-0";
export var systemMessage = "_hx-1";
export var systemMessageWrapper = "_hx-2";